module.exports = __webpack_public_path__ + "img/ico-import.01781634.svg";